import React, { useEffect, useState } from "react";
import ButtonComponent from "../shared/button/button.component";
import { Link } from "react-router-dom";
import { AppRoutes } from "../routes/route.path";
import { CancelIcon, ChannelWhiteIcon, LiveChatNotConnectedIcon, LiveChatSuccesfullyConnectedIcon } from "../../icon";
import { LiveChatService } from "../../services/channels/LiveChatService";
import setToast from "../../helpers/toaster.helper";
import { ToasterType } from "../shared/toaster/toaster.model";
import { mapToUser } from "../../models/conversations";
import { UserModel } from "../../models/users.model";
import { Dialog, DialogTitle, DialogContent, DialogActions, Tooltip } from "@mui/material";
import { LoadChannels } from "../../actions";
import { useDispatch } from "react-redux";
import { ChannelUserService } from "../../services/ChannelUserService";


interface Iprops {
    WidgetTitle: string;
    ChannelId: string;
    Hide?: boolean;
    handleClose?: (value: boolean) => void;
    HandleNext?: (data) => void;
}

const LiveChatValidate: React.FC<Iprops> = (props: Iprops) => {
    const dispatch = useDispatch()

    const [verified, setVerified] = useState<boolean>(false);
    const [PermissionsAgreed, setPermissionsAgreed] = useState<boolean>(false);
    const [dialogBoxOpen, setDialogBoxOpen] = useState<boolean>(false);
    const [websiteUrl, setWebsiteUrl] = useState<string>("");
    const [isLoading, setIsLoading] = useState<boolean>(false);


    useEffect(() => {
        if (!props.WidgetTitle) {
            setToast("Widget Title has been missing,Please start from first step!", ToasterType.DANGER, "never")
        }
    }, [props.WidgetTitle])

    const handleVerification = () => {
        setDialogBoxOpen(true)
    }

    const closeDialogBox = () => {
        setDialogBoxOpen(false)
        setVerified(false)
        setPermissionsAgreed(false)
        if (!!props?.handleClose) {
            props?.handleClose((PermissionsAgreed && verified))
        }

    }

    const user = mapToUser(JSON.parse(localStorage.getItem("current-user"))) as UserModel;
    const HandleAgreement = () => {
        setIsLoading(true)
        LiveChatService.ValidateLiveChat(props.ChannelId, { weburl: websiteUrl }).then(res => {
            if (res.data === true) {
                setVerified(res.data)
                setPermissionsAgreed(true)
                setIsLoading(false)
                LoadChannels(dispatch, ChannelUserService.getCurrentUserFromLocalStorage().OrganizationID)
            }
            if (res.data === false) {
                setToast(`Canot find live chat at "${websiteUrl}"`, ToasterType.DANGER, "default")
                setPermissionsAgreed(true)
                setIsLoading(false)
            }
        }).catch(res => {
            if (!!res) {
                setToast(`Please enter a valid URL`, ToasterType.DANGER, "default")
                setPermissionsAgreed(true)
                setIsLoading(false)
            }
        })
    }

    const handleWebsiteUrl = (e) => {
        setWebsiteUrl(e.target.value)
    }

    return (
        <>
            <div className="add-phone-number-paper-border paper-background h-p-90 m-auto br-2 d-flex flex-direction">
                {!props.Hide &&
                    <div className="w-p-85 h-p-15 mx-auto o-hidden d-flex align-end h2-semibold ">
                        Website URL
                    </div>}
                {!props.Hide &&
                    <div className="w-p-85 h-p-5 mx-auto o-hidden h4-regular d-flex align-end">
                        Enter the URL of the website where the live chat has been integrated
                    </div>}
                <div className={`w-p-85 ${props.Hide ? "h-p-70" : "h-p-40 channel-embedd-code-border"} mx-auto o-hidden my-2 br-1`}>
                    <div className={` ${props.Hide ? "ml-2" : "ml-5"} h-p-20 h2-regular d-flex align-end`} >Enter Your Website Url Here</div>
                    <div className={` d-flex ${props.Hide ? "ml-2" : "ml-5"} align-center h-p-40`}>
                        <input className="bg-color-channel-input w-p-94 h-p-40 b-none br-1 h3-semibold" value={websiteUrl} onChange={handleWebsiteUrl}></input>
                    </div>
                    <div className={` d-flex ${props.Hide ? "ml-2" : "ml-5"} align-center h-p-20 color-primary-danger h4-regular`}>
                        *Live chat has been integrated with the website and was made available online.
                    </div>
                </div>
                <div className=" w-p-85 h-p-10 mx-auto">
                    <span className="d-flex justify-flex-end">
                        <ButtonComponent ButtonLabel={"Verify and Connect"} OnClick={handleVerification} Variant={!!websiteUrl.trim() && props.WidgetTitle ? "primary-btn" : "disabled-btn"} ClassName=""></ButtonComponent>
                    </span>
                </div>
            </div>

            {dialogBoxOpen &&
                <>
                    {!PermissionsAgreed ?
                        <Dialog
                            maxWidth='md'
                            open={true}
                            onClose={() => { }}
                            aria-labelledby="alert-dialog-title"
                            aria-describedby="alert-dialog-description"
                            BackdropProps={{ style: { backgroundColor: "transparent" } }} classes={{ paper: "w-70 br-2  dialogue-shadow" }}
                        >
                            <DialogTitle id="alert-dialog-title">
                                <div className="h2-regular color-text-field-font d-flex">
                                    <div className="w-p-94 t-align-center">
                                        Permissions</div>
                                    <Tooltip title='Close' placement='bottom' onClick={closeDialogBox}>
                                        <span className={"ml-auto c-pointer"}>
                                            <CancelIcon />
                                        </span>
                                    </Tooltip>
                                </div>
                            </DialogTitle>
                            <DialogContent className={` w-p-91 pb-0`}>
                                <div className="h4-semibold">
                                    Thank you for choosing Falkon Live Chat. Before we proceed, please take a moment to review and agree to the following terms and conditions:
                                </div>
                                <div className="bg-color-nav-bar br-2 my-1">
                                    <div className="h4-regular p-1">
                                        <span className="h4-semibold">1.Website Crawl:</span> By granting permission, you allow our system to crawl your website to check if the Live Chat widget code is present. This is necessary to ensure proper functionality and to provide a seamless chat experience for your visitors.
                                    </div>
                                    <div className="h4-regular p-1">
                                        <span className="h4-semibold">2.Data Collection:</span> During the website crawl, our system may collect certain information, including but not limited to website URLs, HTML code snippets, and metadata. This information is solely used for the purpose of verifying the presence of the Live Chat widget code and will not be shared with any third parties.
                                    </div>
                                    <div className="h4-regular p-1">
                                        <span className="h4-semibold">3.Ownership Confirmation:</span> As part of the validation process, we kindly ask you to confirm if the website mentioned belongs to you or if you have authorized access to it. This helps us ensure that the Live Chat service is being used appropriately and in accordance with the website owner's consent.
                                    </div>
                                </div>
                                <div className="live-chat-dashed-border">
                                    <div className="h4-regular p-1">
                                        By clicking "I Agree" or granting permission for website crawling, you signify your acceptance of these terms and conditions.
                                    </div>
                                </div>
                                <div className="d-flex justify-center align-center mt-1">
                                    <ButtonComponent ButtonLabel={"Decline"} Variant={"secondary-btn"} ClassName="mr-3 " OnClick={closeDialogBox}></ButtonComponent>
                                    <ButtonComponent ButtonLabel={"I Agree"} Loading={isLoading} OnClick={HandleAgreement} Variant={"primary-btn"} ClassName=""></ButtonComponent>
                                </div>
                            </DialogContent>
                            <DialogActions className={`m-1`}></DialogActions>
                        </Dialog >
                        :
                        <>
                            {PermissionsAgreed && verified ?
                                < Dialog
                                    maxWidth='md'
                                    open={true}
                                    onClose={() => { }}
                                    aria-labelledby="alert-dialog-title"
                                    aria-describedby="alert-dialog-description"
                                    BackdropProps={{ style: { backgroundColor: "transparent" } }} classes={{ paper: "w-75 h-60 br-2  dialogue-shadow" }}
                                >
                                    {props.Hide &&
                                        <DialogTitle id="alert-dialog-title">
                                            <div className="h2-semibold color-text-field-font d-flex">
                                                <Tooltip title='Close' placement='bottom'>
                                                    <span className={"ml-auto"}>
                                                        <CancelIcon className={"c-pointer"} onClick={closeDialogBox} />
                                                    </span>
                                                </Tooltip>
                                            </div>
                                        </DialogTitle>
                                    }
                                    <DialogContent className={` w-p-91 pb-0`}>
                                        <div className={` paper-background m-auto br-2 d-flex flex-direction ${props.Hide ? "add-phone-number-paper-border h-p-86" : "h-p-95"}`}>
                                            <div className={`${props.Hide ? "h-p-80" : "h-p-60"} d-flex justify-center align-center`}>
                                                <LiveChatSuccesfullyConnectedIcon />
                                            </div>
                                            <div className="h-p-20 t-align-center d-flex justify-center align-center color-secondary-success h2-semibold">
                                                Live Chat Successfully Connected!
                                            </div>
                                            {!props.Hide &&
                                                <div className="h-p-20 d-flex justify-center align-center">
                                                    <Link to={AppRoutes.CHANNELS}>
                                                        <ButtonComponent Icon={ChannelWhiteIcon} ButtonLabel={"Go To Channels"} Variant={"primary-btn"} ClassName=""></ButtonComponent>
                                                    </Link>
                                                </div>
                                            }
                                        </div>
                                    </DialogContent>
                                </Dialog >
                                :
                                < Dialog
                                    maxWidth='md'
                                    open={true}
                                    onClose={() => { }}
                                    aria-labelledby="alert-dialog-title"
                                    aria-describedby="alert-dialog-description"
                                    BackdropProps={{ style: { backgroundColor: "transparent" } }} classes={{ paper: "w-75 h-60 br-2  dialogue-shadow" }}
                                >
                                    {props.Hide && <DialogTitle id="alert-dialog-title">
                                        <div className="h2-semibold color-text-field-font d-flex">
                                            <Tooltip title='Close' placement='bottom'>
                                                <span className={"ml-auto"}>
                                                    <CancelIcon className={"c-pointer"} onClick={closeDialogBox} />
                                                </span>
                                            </Tooltip>
                                        </div>
                                    </DialogTitle>
                                    }
                                    <DialogContent className={` w-p-91 pb-0`}>
                                        <div className={` paper-background m-auto br-2 d-flex flex-direction ${props.Hide ? "add-phone-number-paper-border h-p-86" : "h-p-95 "}`}>
                                            <div className={`${props.Hide ? "h-p-70" : "h-p-60"} d-flex justify-center align-center`}>
                                                <LiveChatNotConnectedIcon />
                                            </div>
                                            <div className="h-p-20 t-align-center d-flex justify-center align-center color-primary-danger h2-semibold">
                                                Live chat has not connected
                                            </div>
                                            {!props.Hide &&
                                                <div className="h-p-20 d-flex justify-center align-center">
                                                    <ButtonComponent ButtonLabel={"Validate Again"} Variant={"secondary-btn"} ClassName="mr-3 " OnClick={closeDialogBox}></ButtonComponent>
                                                    <Link to={AppRoutes.CHANNELS}>
                                                        <ButtonComponent Icon={ChannelWhiteIcon} ButtonLabel={"Go To Channels"} Variant={"primary-btn"} ClassName=""></ButtonComponent>
                                                    </Link>
                                                </div>
                                            }
                                        </div>
                                    </DialogContent>
                                </Dialog >
                            }
                        </>
                    }
                </>
            }

        </>
    )
}


export default LiveChatValidate;